module.exports = __webpack_public_path__ + "static/media/5.Thumbs Up 1.6eb1dec9.gif";